export const getColumnDefsFromData = (data) => {
  if (!data || data.length === 0) return [];

  // get keys from first row
  const firstRow = data[0];

  return Object.keys(firstRow).map((key) => ({
    field: key,
    headerName: key,
    flex: 1,
  }));
};

export function mergeLMPByHourEnding(obj1, obj2, currentHE = 1) {
  // normalize currentHE
  if (currentHE == null) currentHE = 1;

  // if obj2 is empty or invalid, just return obj1
  if (!Array.isArray(obj2) || obj2.length === 0) {
    return obj1;
  }

  // build lookup map for obj2
  const obj2Map = new Map(
    obj2.map(item => [item.HourEnding, item])
  );

  return obj1.map(item => {
    const he = item.HourEnding;

    if (he > currentHE && obj2Map.has(he)) {
      return {
        ...item,
        LMP: obj2Map.get(he).LMP
      };
    }

    return item;
  });
}

export function getFilteredColumnDefs({
  data,
  classType,
  onPeakHours = null,
  offPeakHours = null,
  wePeakHours = null,
  isMobile = false,
  currentHE,
}) {
  const fixedCols = ["Zone", "Type"];

  // Base columns (always shown)
  const baseColDefs = [
    {
      field: "Zone",
      headerName: "Zone",
      width: isMobile ? 100 : 150,
      pinned: "left",
      cellStyle: () => ({ fontSize: "14px" }),
    },
    {
      field: "Type",
      headerName: "Type",
      width: isMobile ? 100 : 150,
      pinned: "left",
      cellStyle: () => ({ fontSize: "14px" }),
    },
  ];

  console.log(data);
  

  // Guard clause
  if (!Array.isArray(data) || data.length === 0) {
    return baseColDefs;
  }

  // Select hours based on class
  let selectedHours = [];
  switch (classType?.toLowerCase()) {
    case "onpeak":
      selectedHours = onPeakHours || [];
      break;
    case "offpeak":
      selectedHours = offPeakHours || [];
      break;
    case "wepeak":
      selectedHours = wePeakHours || [];
      break;
    default:
      selectedHours = [];
  }

  // Convert hours → "01" format
  const allowedCols = selectedHours.map((h) =>
    String(h).padStart(2, "0")
  );
  console.log(allowedCols);
  

  // Generate hour columns from data
  const additionalColDefs = Object.keys(data[0])
    .filter((key) => !fixedCols.includes(key))
    .filter((key) => allowedCols.includes(key))
    .sort((a, b) => Number(a) - Number(b))
    .map((key) => ({
      field: key,
      headerName: `HE${key}`,
      width: isMobile ? 90 : 98,
      cellStyle: () => {
        if (key === currentHE) {
          return {
            backgroundColor: "#90CAF9",
            color: "#000",
            fontWeight: "bold",
            fontSize: "14px",
          };
        }
        return { fontSize: "14px" };
      },
    }));

  return [...baseColDefs, ...additionalColDefs];
}
